import { useQuery } from '@tanstack/react-query';
import { fetchAuditById } from '@/api/audits';

export const auditDetailKeys = {
  detail: (id: string) => ['audits', 'detail', id] as const,
};

export function useAuditDetail(id: string) {
  return useQuery({
    queryKey: auditDetailKeys.detail(id),
    queryFn: async () => (await fetchAuditById(id)).data,
    staleTime: 60_000,
  });
}
